import {connect} from "react-redux";
import ServicesPage from "./ServicesPage";
import * as InfrastructureApiActions from "../../actions/InfrastructureApiActions";
import * as ViewActions from "../../actions/ViewActions";

export default connect(null, {...InfrastructureApiActions, ...ViewActions})(ServicesPage);